module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAONJREFUWEftlkFqAkEQRd9XAgGvY0gWLrJQdA4VFx4qJJhFFi4UvY4giKnQ0APOJNBDD+OAVO8aiq7f70P9Ej0f9dwfF5BNwMwegW9gCLxKOubY2UbAFFjHpgtJn7cWUADvsWkh6cMFOAEncB8EzGwETIBB4kdjYBVrlsAhUX8GNpJO13V/JqGZ7YHweBdnJ+klJWALPHfRPVCS9JQSEEImWPBQE2G1e3iotODtHwvqdH+iBZXQahNGngVOwAk4gTlQ7oEzSV8507PNIAqhFdbyS1zLKyHTVEy2gKYNUnUuoHcCv8NYgCFQpHMrAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_icon_add.png
// module id = 2n8X
// module chunks = 0